var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScaleViewerMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "415px",
    height: "38px",
    viewBox: "0 0 415 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 10\u5907\u4EFD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scale-viewer-mobile_svg__\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scale-viewer-mobile_svg__\\u753B\\u677F",
    transform: "translate(-649.000000, -54.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scale-viewer-mobile_svg__\\u7F16\\u7EC4-10\\u5907\\u4EFD",
    transform: "translate(649.679688, 54.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scale-viewer-mobile_svg__\\u7F16\\u7EC4-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scale-viewer-mobile_svg__\\u7F16\\u7EC4-15"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 25.7802541,
    y1: 14.3733104,
    x2: 25.7802541,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.40997242,
    y1: 21.5599656,
    x2: 6.40997242,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-3",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.2370146,
    y1: 21.5599656,
    x2: 32.2370146,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-6",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.4945075,
    y1: 21.5599656,
    x2: 58.4945075,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-9",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.3215497,
    y1: 21.5599656,
    x2: 84.3215497,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-24",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.866733,
    y1: 21.5599656,
    x2: 12.866733,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-4",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.6937751,
    y1: 21.5599656,
    x2: 38.6937751,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-7",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.951268,
    y1: 21.5599656,
    x2: 64.951268,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-10",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.7783102,
    y1: 21.5599656,
    x2: 90.7783102,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-26",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.3234935,
    y1: 21.5599656,
    x2: 19.3234935,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-5",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.1505357,
    y1: 21.5599656,
    x2: 45.1505357,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-8",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.4080286,
    y1: 21.5599656,
    x2: 71.4080286,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-11",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.2350707,
    y1: 21.5599656,
    x2: 97.2350707,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-27",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.598887935,
    y1: 0.598887935,
    x2: 0.598887935,
    y2: 36.532164,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-2",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.0377469,
    y1: 14.3733104,
    x2: 52.0377469,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.8647891,
    y1: 14.3733104,
    x2: 77.8647891,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-28",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    id: "scale-viewer-mobile_svg__1",
    fontFamily: "PingFangSC-Semibold, PingFang SC",
    fontSize: 10,
    fontWeight: 500,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2.44233986,
    y: 11.3844311
  }, "1"))), /*#__PURE__*/React.createElement("g", {
    id: "scale-viewer-mobile_svg__\\u7F16\\u7EC4-15\\u5907\\u4EFD-2",
    transform: "translate(206.616337, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 25.7802541,
    y1: 14.3733104,
    x2: 25.7802541,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.40997242,
    y1: 21.5599656,
    x2: 6.40997242,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-3",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.2370146,
    y1: 21.5599656,
    x2: 32.2370146,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-6",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.4945075,
    y1: 21.5599656,
    x2: 58.4945075,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-9",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.3215497,
    y1: 21.5599656,
    x2: 84.3215497,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-24",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.866733,
    y1: 21.5599656,
    x2: 12.866733,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-4",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.6937751,
    y1: 21.5599656,
    x2: 38.6937751,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-7",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.951268,
    y1: 21.5599656,
    x2: 64.951268,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-10",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.7783102,
    y1: 21.5599656,
    x2: 90.7783102,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-26",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.3234935,
    y1: 21.5599656,
    x2: 19.3234935,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-5",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.1505357,
    y1: 21.5599656,
    x2: 45.1505357,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-8",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.4080286,
    y1: 21.5599656,
    x2: 71.4080286,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-11",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.2350707,
    y1: 21.5599656,
    x2: 97.2350707,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-27",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.598887935,
    y1: 0.598887935,
    x2: 0.598887935,
    y2: 36.532164,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-2",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.0377469,
    y1: 14.3733104,
    x2: 52.0377469,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.8647891,
    y1: 14.3733104,
    x2: 77.8647891,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-28",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    id: "scale-viewer-mobile_svg__3",
    fontFamily: "PingFangSC-Semibold, PingFang SC",
    fontSize: 10,
    fontWeight: 500,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2.44233986,
    y: 11.3844311
  }, "3"))), /*#__PURE__*/React.createElement("g", {
    id: "scale-viewer-mobile_svg__\\u7F16\\u7EC4-15\\u5907\\u4EFD",
    transform: "translate(103.308169, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 25.7802541,
    y1: 14.3733104,
    x2: 25.7802541,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.40997242,
    y1: 21.5599656,
    x2: 6.40997242,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-3",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.2370146,
    y1: 21.5599656,
    x2: 32.2370146,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-6",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.4945075,
    y1: 21.5599656,
    x2: 58.4945075,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-9",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.3215497,
    y1: 21.5599656,
    x2: 84.3215497,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-24",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.866733,
    y1: 21.5599656,
    x2: 12.866733,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-4",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.6937751,
    y1: 21.5599656,
    x2: 38.6937751,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-7",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.951268,
    y1: 21.5599656,
    x2: 64.951268,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-10",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.7783102,
    y1: 21.5599656,
    x2: 90.7783102,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-26",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.3234935,
    y1: 21.5599656,
    x2: 19.3234935,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-5",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.1505357,
    y1: 21.5599656,
    x2: 45.1505357,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-8",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.4080286,
    y1: 21.5599656,
    x2: 71.4080286,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-11",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.2350707,
    y1: 21.5599656,
    x2: 97.2350707,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-27",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.598887935,
    y1: 0.598887935,
    x2: 0.598887935,
    y2: 36.532164,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-2",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.0377469,
    y1: 14.3733104,
    x2: 52.0377469,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.8647891,
    y1: 14.3733104,
    x2: 77.8647891,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-28",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    id: "scale-viewer-mobile_svg__2",
    fontFamily: "PingFangSC-Semibold, PingFang SC",
    fontSize: 10,
    fontWeight: 500,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2.44233986,
    y: 11.3844311
  }, "2"))), /*#__PURE__*/React.createElement("g", {
    id: "scale-viewer-mobile_svg__\\u7F16\\u7EC4-15\\u5907\\u4EFD-3",
    transform: "translate(309.924506, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 25.7802541,
    y1: 14.3733104,
    x2: 25.7802541,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.40997242,
    y1: 21.5599656,
    x2: 6.40997242,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-3",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.2370146,
    y1: 21.5599656,
    x2: 32.2370146,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-6",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.4945075,
    y1: 21.5599656,
    x2: 58.4945075,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-9",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.3215497,
    y1: 21.5599656,
    x2: 84.3215497,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-24",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.866733,
    y1: 21.5599656,
    x2: 12.866733,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-4",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.6937751,
    y1: 21.5599656,
    x2: 38.6937751,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-7",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.951268,
    y1: 21.5599656,
    x2: 64.951268,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-10",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.7783102,
    y1: 21.5599656,
    x2: 90.7783102,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-26",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.3234935,
    y1: 21.5599656,
    x2: 19.3234935,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-5",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.1505357,
    y1: 21.5599656,
    x2: 45.1505357,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-8",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.4080286,
    y1: 21.5599656,
    x2: 71.4080286,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-11",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.2350707,
    y1: 21.5599656,
    x2: 97.2350707,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-27",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.598887935,
    y1: 0.598887935,
    x2: 0.598887935,
    y2: 36.532164,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-2",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.0377469,
    y1: 14.3733104,
    x2: 52.0377469,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.8647891,
    y1: 14.3733104,
    x2: 77.8647891,
    y2: 35.9332761,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-28",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.476606,
    y1: 0.598887935,
    x2: 103.476606,
    y2: 36.532164,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-29",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    id: "scale-viewer-mobile_svg__4",
    fontFamily: "PingFangSC-Semibold, PingFang SC",
    fontSize: 10,
    fontWeight: 500,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2.44233986,
    y: 11.3844311
  }, "4")))), /*#__PURE__*/React.createElement("line", {
    x1: 0.383662583,
    y1: 36.3822858,
    x2: 413.616323,
    y2: 36.6820422,
    id: "scale-viewer-mobile_svg__\\u8DEF\\u5F84-6",
    stroke: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleViewerMobile);
export default __webpack_public_path__ + "static/media/scale-viewer-mobile.e3abd40b.svg";
export { ForwardRef as ReactComponent };